export default {
    SET_PROMPT_PAGINATED(state, prompts) {
        state.prompts = prompts;
    },
    ADD_PROMPT(state, prompt) {
        state.prompts.items.unshift(prompt);
    },
    UPDATE_PROMPT(state, prompt) {
        const promptIndex = state.prompts.items.findIndex(
            item  => item.id === prompt.id
        );

        Object.assign(
            state.prompts.items[ promptIndex ],
            prompt
        );
    },
    DELETE_PROMPT(state, promptId) {
        const promptIndex = state.prompts.items.findIndex(
            item  => item.id === promptId
        );

        state.prompts.items.splice(promptIndex, 1);
    },
    SET_PROMPT_INFOS(state, prompt) {
        if ( state.prompts.infos === undefined ) {
            state.prompts.infos = [];
        }

        state.prompts.infos = [ ...prompt.items ];
    },
    UPDATE_PROMPT_INFOS(state, prompt) {
        const promptIndex = state.prompts.infos.findIndex(
            item  => item.id === prompt.id
        );

        Object.assign(
            state.prompts.infos[ promptIndex ],
            prompt
        );
    },
    ADD_PROMPT_INFOS(state, prompt) {
        if ( state.prompts.infos === undefined ) {
            state.prompts.infos = [];
        }

        state.prompts.infos.unshift(prompt);
    }
}